'use client';

import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';

interface PriceItem {
  id: string;
  product: string;
  weight: string;
  purity: string;
  ankauf: string;
  verkaufNetto: string;
  verkaufBrutto: string;
  category: 'gold' | 'silver';
}

interface PriceTableMobileCardProps {
  item: PriceItem;
}

const PriceTableMobileCard = ({ item }: PriceTableMobileCardProps) => {
  const { t } = useLanguage();

  return (
    <div className="bg-card rounded-lg shadow-elevation-sm p-5 border border-border">
      <div className="mb-4">
        <h3 className="font-heading text-base font-semibold text-foreground mb-1">
          {item.product}
        </h3>
        <p className="font-body text-sm text-muted-foreground">
          {item.weight} • {item.purity}
        </p>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex justify-between items-center">
          <span className="font-body text-sm text-muted-foreground">{t('priceList.table.ankauf')}:</span>
          <span className="font-heading text-base font-bold text-accent">{item.ankauf}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="font-body text-sm text-muted-foreground">{t('priceList.table.verkaufNetto')}:</span>
          <span className="font-heading text-base font-bold text-accent">{item.verkaufNetto}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="font-body text-sm text-muted-foreground">{t('priceList.table.verkaufBrutto')}:</span>
          <span className="font-heading text-base font-bold text-accent">{item.verkaufBrutto}</span>
        </div>
      </div>
      <CTAButton href="/contact" variant="primary" className="w-full text-sm">
        {t('common.contactUs')}
      </CTAButton>
    </div>
  );
};

export default PriceTableMobileCard;